<template>
  <div class="bg-white drop-shadow-lg shadow-2xl p-8">
    <p
      v-if="form.date"
      class="uppercase text-xs mb-3 font-AvenirBlackFont text-right"
    >
      for immediate release {{ form.date | formatDate }}
    </p>

    <img
      v-if="image"
      class="mx-auto my-4 rounded"
      :src="image"
      alt="ShotTracker"
    />

    <p v-if="form.header" class="text-md text-center font-AvenirBlackFont">
      {{ form.header }}
    </p>

    <p
      v-if="form.subheader"
      class="italic lg:text-md text-sm text-center font-QuestrialFont my-2"
    >
      {{ form.subheader }}
    </p>

    <MarkdownPreview :text="form.body" />
  </div>
</template>

<script>
import MarkdownPreview from "../../MarkdownPreview.vue";
import "../../../utils/filters";

export default {
  name: "PressReleasePreview",

  props: {
    form: Object,
    image: String,
  },

  components: {
    MarkdownPreview,
  },
};
</script>




